export default __webpack_public_path__ + "static/port-4mb-7a73c277df632764d856dffa4fa6d673.mp4";